module.exports = __webpack_public_path__ + "img/event2412_6.c894e352.png";